export const TAKE_AWAY_NOT_PERMITTED : string = "TAKE_AWAY_NOT_PERMITTED"
export type PAYMENT_METHOD_TYPE = "cash" | "stripe" | "satispay" | "wallet"
